import { useState } from "react";
import { throwResponseError } from "../../../utils/api-error-utils";
import { getAuthParams } from "../../../utils/pacto-rebates-utils";
import { formatHolidayResponse } from "../../utils/holiday-utils";

export function useHolidayById() {
	const [holiday, setHoliday] = useState(null);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);

	async function fetchHolidayById(idFeriado) {
		if (!idFeriado) {
			const message = "Não foi possível identificar o feriado.";

			setHoliday(null);
			setError(message);

			return {
				ok: false,
				reason: "validation",
				error: message
			};
		}

		try {
			setLoading(true);
			setError(null);

			const { accessToken, clientId } = getAuthParams();

			const response = await fetch(
				process.env.REACT_APP_ESSILOR_API +
					`pacto-rebates-admin/v1/feriados/${idFeriado}`,
				{
					method: "GET",
					headers: {
						"Content-Type": "application/json",
						"access_token": accessToken,
						"client_id": clientId
					}
				}
			);

			if (!response.ok) {
				await throwResponseError(response, "Erro ao buscar feriado.");
			}

			const data = await response.json();
			const formattedHoliday = formatHolidayResponse(data);

			setHoliday(formattedHoliday);

			return {
				ok: true,
				holiday: formattedHoliday
			};
		} catch (requestError) {
			const errorMessage =
				requestError.message || "Erro ao buscar feriado.";

			setHoliday(null);
			setError(errorMessage);

			return {
				ok: false,
				reason: "request",
				error: errorMessage
			};
		} finally {
			setLoading(false);
		}
	}

	const clearHoliday = () => {
		setHoliday(null);
		setError(null);
	};

	return {
		holiday,
		loading,
		error,
		refetch: fetchHolidayById,
		clearHoliday
	};
}